import { loadCategoryDetails } from "../redux/actions";

/**
 * @property {RootStore} rootStore
 * @property {(id) => string} t
 */
export class AnalyticsDataStore {   
    gaTrackingId = 'GTM-NWFKH6B9';
    
    getCategoryDetails = async (categoryId) => {
        const categories_list_data = await loadCategoryDetails(categoryId);
        return {
          current: categories_list_data?.current_category || '',
          list: categories_list_data?.categories_list || {}
        };
    };

    select_item = async(product, event_name, region) => {         
        const { current, list } = await this.getCategoryDetails(product?.categories[0]?.id);
        
        const values = {
            item_id        : product?.product_variations[0]?.sku,
            item_name      : product?.name,
            item_brand     : product?.brand[0]?.name,
            item_category  : current,
            item_category2 : list?.name || '',
            item_category3 : list?.parent?.name || '',
            item_category4 : list?.parent?.parent?.name || '',
            item_variant   : product?.product_variations[0]?.name,
            price          : product?.product_variations[0]?.base_gross_price,
            quantity       : 1
        };            
        this.send_item_to_analytics(values, event_name, region);
    };

    add_to_cart = async(product, variation, event_name, quantity) => { 
        const { current, list } = await this.getCategoryDetails(product?.categories[0]?.id);
        
        const values = {
            item_id        : variation?.sku,
            item_name      : product?.name,
            item_brand     : product?.brand[0]?.name,
            item_category  : current,
            item_category2 : list?.name || '',
            item_category3 : list?.parent?.name || '',
            item_category4 : list?.parent?.parent?.name || '',
            item_variant   : variation?.name,
            price          : variation?.base_gross_price,
            quantity       : quantity
        };            
        this.send_item_to_analytics(values, event_name);
    };

    add_to_cart_from_modal = async(variation, event_name, quantity) => { 
        const values = {
            item_id        : variation?.sku,
            item_variant   : variation?.name,
            price          : variation?.base_gross_price,
            quantity       : quantity
        };   
        this.send_item_to_analytics(values, event_name);
    };

    add_to_cart_from_agreed = async(event_name, item, quantity) => {         
        const values = {            
            item_name      : item?.name,
            item_id        : item?.product_variations?.sku,
            item_variant   : item?.product_variations?.name,
            price          : item?.price,
            quantity       : quantity
        };    
        this.send_item_to_analytics(values, event_name);
    };

    add_to_cart_from_comparison = async(productVariation, event_name, brand, code, name) => {
        const values = {
            item_id        : code,
            item_name      : name,
            item_brand     : brand,
            item_variant   : productVariation?.name,
            price          : productVariation?.base_gross_price,
            quantity       : 1
        };   
        this.send_item_to_analytics(values, event_name);
    };

    remove_from_cart = async(productVariation) => {
        let product = JSON.parse(JSON.stringify(productVariation.product));
        const { current, list } = await this.getCategoryDetails(product?.categories[0]?.id);

        let single_carts = {
            item_id        : productVariation?.sku,
            item_name      : product?.name,
            item_brand     : product?.brand[0]?.name,
            item_category  : current,
            item_category2 : list?.name || '',
            item_category3 : list?.parent?.name || '',
            item_category4 : list?.parent?.parent?.name || '',
            item_variant   : productVariation?.name,
            price          : productVariation?.base_gross_price,
            quantity       : 0
        };   
        this.send_item_to_analytics(single_carts, 'remove_from_cart');
    };

    view_cart = async(carts) => {
        if(carts.length > 0) {
            const cart_datas = await this.view_cart_data_loading(carts);             
            this.send_items_to_analytics(cart_datas, 'view_cart');
        }
    };

    view_cart_data_loading = async (carts) => {
        const cart_datas = [];
      
        for (const location_cart of carts) {
            const lines = location_cart.lines || [];
            const processed = await Promise.all(lines.map(async (cart_data) => {
                const productVariation = cart_data.product_variation;
                const product = JSON.parse(JSON.stringify(productVariation.product));
        
                return {
                    item_id: productVariation?.sku,
                    item_name: product?.name,
                    item_brand: product?.brand?.[0]?.name,
                    item_category: product?.categories?.[0]?.name,
                    item_variant: productVariation?.name,
                    price: productVariation?.base_gross_price,
                    quantity: cart_data.quantity
                };
            }));
            cart_datas.push(...processed);
        }      
        return cart_datas;
    };

    begin_checkout = async(selectedCarts, summary, region) => {        
        if(selectedCarts.length > 0) {
            const cart_datas = await this.view_cart_data_loading(selectedCarts);            
             
            if (!this.gaTrackingId) return false;

            window.dataLayer = window.dataLayer || [];
            
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event     : 'begin_checkout',
                ecommerce : {
                    currency : region,
                    value    : summary?.total_net,
                    items    : cart_datas
                }
            }); 
        }
    };

    view_item = async(products) => {
        if(products.length > 0) {
            const datas = [];           

            for (const product of products) {
                const single_cart = {
                    item_name     : product?.name,
                    item_brand    : product?.brand[0]?.name,
                    item_category : product?.categories[0]?.name,
                    price         : product?.min_base_gross_price,
                    quantity      : 1
                };
                datas.push(single_cart);
            }             
            this.send_items_to_analytics(datas, 'view_item');
        }
    };

    send_item_to_analytics = async(values, event_name, region) => { 
        if (!this.gaTrackingId) return false;

        window.dataLayer = window.dataLayer || [];
        
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event     : event_name,
            ecommerce : {
                currency : region,
                items    : [values]
            }
        }); 
    };

    send_items_to_analytics = async(values, event_name, region) => { 
        if (!this.gaTrackingId) return false;

        window.dataLayer = window.dataLayer || [];
        
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event     : event_name,
            ecommerce : {
                currency : region,
                items    : values
            }
        }); 
    };

    purchase = async(selectedCarts, selectedLinesSummaries, reference, payment_method, region) => {
        let selectedLinesSummary = JSON.parse(JSON.stringify(selectedLinesSummaries));
        let cart_datas = [];

        if(selectedCarts.length > 0) {
            cart_datas = await this.view_cart_data_loading(selectedCarts);       

            if(cart_datas.length > 0) {
                if (!this.gaTrackingId) return false;

                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event           : 'add_payment_info',  
                    ecommerce       : {
                        currency    : region,
                        value       : selectedLinesSummary?.total,
                        payment_type: payment_method,
                        items       : cart_datas
                    }
                }); 

                window.dataLayer.push({ ecommerce: null });
                window.dataLayer.push({
                    event             : 'purchase',
                    ecommerce         : {
                        currency      : region,
                        transaction_id: reference,
                        value         : selectedLinesSummary?.total,
                        tax           : selectedLinesSummary?.vat,
                        shipping      : selectedLinesSummary?.shipping,
                        coupon        : selectedLinesSummary?.promotion,
                        items         : cart_datas
                    }
                }); 
                return true;
            }
        }
    };
}
